import { ChatConfig } from '../types';

// Environment-based configuration
const config: ChatConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://nfc-session-docker-625915153805.us-central1.run.app',
  websocketUrl: import.meta.env.VITE_WEBSOCKET_URL || 'wss://nfc-session-docker-625915153805.us-central1.run.app',
  gptRelayUrl: import.meta.env.VITE_GPT_RELAY_URL || 'https://gpt-chat-relay-wusgso4mxq-uc.a.run.app',
  maxMessageLength: parseInt(import.meta.env.VITE_MAX_MESSAGE_LENGTH || '1000'),
  sessionTimeoutMinutes: parseInt(import.meta.env.VITE_SESSION_TIMEOUT_MINUTES || '60'),
  reconnectAttempts: parseInt(import.meta.env.VITE_RECONNECT_ATTEMPTS || '5'),
  reconnectDelay: parseInt(import.meta.env.VITE_RECONNECT_DELAY || '2000'),
};

// Validation
const validateConfig = () => {
  const required = ['apiBaseUrl', 'websocketUrl'];
  const missing = required.filter(key => !config[key as keyof ChatConfig]);
  
  if (missing.length > 0) {
    console.warn('Missing configuration values:', missing);
  }
}; 

validateConfig();

export default config;